
import { Component, Vue } from 'vue-property-decorator'
import RedemptionsList from '@/components/redemption/RedemptionsList.vue'

@Component({
  name: 'Redemptions',
  components: { RedemptionsList }
})
class Redemptions extends Vue {}

export default Redemptions
